import React, {useEffect, useState} from 'react';
import style from './style.module.scss';
import {IProps, IHandlers} from './types';
import {TextField, FormControl, createStyles, Theme, Grid, Typography} from '@material-ui/core';
import {makeStyles} from "@material-ui/core/styles";
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import {ArrowUpward} from "@material-ui/icons";
import {renderIf} from "app/services/reactUtils.service";
import {classPrefix} from "./container";

const NS = 'SectionsMaxOccupancy';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      [`& .${classPrefix}-MuiTextField-root`]: {
        margin: theme.spacing(1)
      },
      flexGrow: 1,
      flexShrink: 0,
    },
  }),
);

export default function SectionsMaxOccupancy({sectionName, maxOccupancy, sectionIndex, sections, enableMaxOccupancy, changeSectionName, changeMaxOccupancy, moveUp, moveDown}: IProps & IHandlers) {

  const [newSectionName, setSectionName] = useState<string>(sectionName);
  const [newMaxOccupancy, setMaxOccupancy] = useState<string>(isNaN(maxOccupancy) || maxOccupancy === null ? '' : maxOccupancy?.toString());
  const classes = useStyles();
  return (

    // <form className={classes.root} noValidate>
    <Grid container className={classes.root} spacing={4} data-testid="max-occupancy-container">
      <Grid item xs={4}>
        <FormControl className={style.textField}>
          <TextField value={newSectionName} name="name" label="Section Name"
                     error={!newSectionName}
                     helperText={newSectionName ? '' : "Section name is required"}
                     data-testid="section-name"
                     onChange={(evt) => {
                       setSectionName(evt.target.value);
                       return changeSectionName(evt.target.value)
                     }}/>
        </FormControl>
      </Grid>
      <Grid item xs={4}>
        {renderIf(enableMaxOccupancy, () => (
          <FormControl className={style.textField}>
            <TextField value={newMaxOccupancy} label="Section max occupancy" name="maxOccupancy"
                       data-testid="section-occupancy"
                       onChange={(evt) => {
                         setMaxOccupancy(evt.target.value);
                         return changeMaxOccupancy(parseFloat(evt.target.value))
                       }}/>
          </FormControl>
        ))}

      </Grid>
      <Grid item xs={4}>
        <div className={style.moveSections}>
          {renderIf(sections && sectionIndex > 0, () => (
            <ArrowUpward fontSize="default" className={style.icons}
                         data-testid="section-up"
                         onClick={() => moveUp(sectionIndex, sections[sectionIndex])}/>
          ))}
          {renderIf(sections && sectionIndex < (sections.length - 1) && sections.length !== 1, () => (
            <ArrowDownwardIcon fontSize="default" className={style.icons}
                               data-testid="section-down"
                               onClick={() => moveDown(sectionIndex, sections[sectionIndex])}/>
          ))}
        </div>
      </Grid>
    </Grid>
    // </form>

  )
}

